(() => {
  const isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isTouchDevice) return;

  let activeLink = null;
  let startX = 0;
  let startY = 0;
  let moved = false;

  const productLinkFromTarget = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest('.template-collection .fomu-catalog-card a[href], .template-collection .product-card-wrapper a.full-unstyled-link[href]');
  };

  document.addEventListener('touchstart', (event) => {
    const touch = event.touches[0];
    const link = productLinkFromTarget(event.target);
    if (!touch || !link) {
      activeLink = null;
      return;
    }
    activeLink = link;
    startX = touch.clientX;
    startY = touch.clientY;
    moved = false;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!activeLink || !event.touches[0]) return;
    const touch = event.touches[0];
    if (Math.abs(touch.clientX - startX) > 10 || Math.abs(touch.clientY - startY) > 10) moved = true;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (!activeLink) return;
    const link = activeLink;
    activeLink = null;
    if (moved || productLinkFromTarget(event.target) !== link) return;
    event.preventDefault();
    window.location.assign(link.href);
  }, { passive: false });

  document.addEventListener('touchcancel', () => {
    activeLink = null;
  }, { passive: true });
})();